<template>
	<div>
		<div class="title">
			<div class="leftTitle" @click="clickLeft">
				<div class="leftTitle" v-if="leftAtive">
					<div class="letf" style="color: #1592E6">财税政策</div>
					<div class="letfLine" style="background-color: #1592E6" />
				</div>

				<div class="leftTitle" v-else>
					<div class="letf" style="color: black">财税政策</div>
					<div class="letfLine" style="background-color: white" />
				</div>
			</div>

			<div class="rightTitle" @click="clickFile">
				<div class="rightTitle" v-if="rightAtive">
					<div class="right" style="color: #1592E6">政策文件</div>
					<div class="rightLine" style="background-color: #1592E6" />
				</div>

				<div class="rightTitle" v-else>
					<div class="right" style="color: black">政策文件</div>
					<div class="rightLine" style="background-color: white" />
				</div>
			</div>
		</div>

		<div class="floatLoad" v-if="!isHide">
			<van-loading size="24px">加载中...</van-loading>
		</div>

		<!--标题相应的内容 -->
		<div v-if="leftAtive" class="image">
			<!--财税-->
			<div class="image" v-if="content !== ''" v-html="content"></div>
			<div v-else class="withoutContent">暂无服务介绍</div>
		</div>

		<div v-else class="file">
			<!--政策文件 -->
			<div v-if="contents.length > 0">
				<div class="cell" v-for="item in contents" :key="item.id">
					<div class="content">
						<div class="fileName">{{ item.name }}</div>
						<a :href="item.url" :underline="false">
							<img class="downLoad" src="../../assets/downLoad.png" />
						</a>
					</div>
				</div>
			</div>
			<div class="withoutContent" v-if="contents.length === 0">暂无相关附件</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'

export default {
	name: 'financialPolicy',
	data() {
		return {
			leftAtive: true,
			rightAtive: false,
			contents: '',
			introduceImage: '',
			isHide: false,
			isOpen: false,
			scrUrl: '',
			content: '',
		}
	},
	watch: {
		communityId() {
			this.getData()
		},
	},

	mounted() {
		this.communityId.length > 0 && this.getData()
	},

	computed: {
		...mapGetters(['token', 'userId', 'communityId']),

		isAndroid() {
			var u = navigator.userAgent
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
			return isiOS ? false : true
		},
	},
	methods: {
		clickHide() {
			this.isOpen = false
		},
		clickLeft() {
			this.leftAtive = true
			this.rightAtive = false
		},
		clickFile() {
			this.leftAtive = false
			this.rightAtive = true
		},
		openPDF(item) {
			if (item.url.substring(item.url.length - 3) === 'pdf') {
				this.isOpen = !this.isOpen
				this.scrUrl = item.url
			} else {
				Toast('只能打开pdf格式文件')
			}
		},
		getData() {
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/financial-policies/status/published`,
				{ communityId: this.communityId },
				(res) => {
					this.isHide = true
					if (res.code !== 1 || res.data.attachs.length === 0) return
					this.contents = []
					this.content = res.data.content
					res.data.attachs.forEach((p) => {
						this.contents.push({
							name: p.attach_name,
							url: p.attach_url,
							isLoad: false,
						})
					})
				},
				(error) => {
					this.isHide = true
					console.log('失败--', error)
				}
			)
		},
	},
}
</script>

<style>
@import '../../assets/common.css';
</style>
